<template>
  <span class="has-text-weight-bold" :class="presenter.class">{{ presenter.label }}</span>
</template>

<script>
export default {
  computed: {
    presenter () {
      const presenter = {}
      if (this.client.suspended_at) {
        presenter.class = 'has-text-warning'
        presenter.label = 'Inactive'
      } else {
        presenter.class = 'has-text-success'
        presenter.label = 'Active'
      }
      return presenter
    }
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  }
}
</script>
